module.exports = __webpack_public_path__ + "img/ico-saida-s.451dbe2a.png";